import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineShoppingBagIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 7h-3V6a3.9998 3.9998 0 0 0-4-4 4 4 0 0 0-4 4v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1.0002 1.0002 0 0 0-1-1Zm-9-1a1.9999 1.9999 0 1 1 4 0v1h-4V6Zm8 13a1.0001 1.0001 0 0 1-1 1H7a1.0002 1.0002 0 0 1-1-1V9h2v1a1 1 0 1 0 2 0V9h4v1a1.0001 1.0001 0 0 0 2 0V9h2v10Z"/>
  </SvgIcon>
}

export default LineShoppingBagIcon
